import { CartSummary, EffectNotification, Item, ProductItem, ShippingDetails, TalonOneItem } from './cart-data.model';
import { TextValue } from './text-value.model';

export class CardPayment {
  Card: string;
  CardHolder: string;
  VbV3DSecure?: boolean;
  CardType: string;
  CSC: string;
  ExpiryMonth: string;
  ExpiryYear: string;
  Valid?: boolean;
  Amount?: number;
  DisplayRemove: boolean;
  TokenId: string;
}
export class PaypalPayment {
  PaypalToken: string;
  PayerID: string;
  PaypalEmail: string;
  AccountStatus: string;
  Amount: number;
}

export class Payments {
  BalanceDue: number;
  TotalAmount: number;
  DisplaySummary: boolean;
  DisplayMessage: string[];
  DisplayPaymentTypes: PaymentType[];
  CardPayment: CardPayment;
  PaymentType: PaymentType;
  GiftCard: GiftCard;
  PaymentValid: boolean;
  DisplayGiftcardForm: boolean;
  PaypalPayment: PaypalPayment;
  PaymentTypesStoreCode: string;
  KlarnaPayment: {
    Session: {
      client_token: string;
      payment_method_categories: KlarnaPaymentMethodCategory[];
      session_id: string;
    };
    authorization_token: string;
  };

  DisableCC: boolean;
  cdevice: string;
  vdevice: string;
  hdevice: string;

  NetworkTokens: NetworkToken[];
}

export interface NetworkToken{
  TokenInstrumentIdentifierId :string;
  CardExpirationYear: string;
  CardExpirationMonth :string;
  CardType :string;
  CardLast4Digits:string;
  CardTypeFullName:string;
  IsDefault:boolean;
}

export interface KlarnaPaymentMethodCategory {
  asset_urls: {
    descriptive: string;
    standard: string;
  };
  identifier: string;
  name: string;
}

export interface GiftCard {
  Card: string;
  Pin: string;
  TotalAmount: number;
  AmountUsed: number;
  AmountUsable: number;
}

export interface CartOrderProfile {
  FirstName: string;
  LastName: string;
  Company: string;
  Phone: string;
  Email: string;
}

export interface CartOrderAddress {
  AddressID?: any;
  FirstName: string;
  LastName: string;
  Company: string;
  Address: string;
  Address2: string;
  City: string;
  StateProvinceID?: number;
  StateProvinceLabel: string;
  StateProvince: string;
  Country: string;
  CountryID: number;
  PostalCode: string;
  IsBillingShipping?: boolean;
  CountryCode: string;
  Phone: string;
}

export interface CartOrder {
  InvoiceNumber: string;
  OrderID: any;
  DisplaySummary: boolean;
  LoggedIn: boolean;
  LoginRequired: boolean;
  FirstName: string;
  LastName: string;
  Email: string;
  Enews: boolean;
  Company: string;
  Phone: string;
  ShippingAddressCompleted: boolean;
  Shipping: CartOrderAddress;
  ShippingDetails: ShippingDetails;
  DisplayMessage: string[];
  Billing: CartOrderAddress;
  BillingAddressCompleted: boolean;
  DisplayBillingSummary: boolean;
  Options: {
    CustomerComments: string;
    AcceptedTerms: boolean;
    AcceptedDropshipTerms: boolean;
    Auth: boolean;
  };
  CountryList: TextValue[];
  StateProvList: TextValue[];
  HideSummary: boolean;
}

export interface BundleSet {
  BundleId: number;
  Items: ProductItem[];
  ItemsCount: number;
  TotalSavings: number;
  Total: number;
}

export class CheckoutData {
  itemCount: number;
  CartID: string;
  CartItems: ProductItem[];
  BundleSets: BundleSet[];
  UnBundledItems: ProductItem[];
  ShippingDetails: ShippingDetails;
  Payments: Payments;
  CheckoutStep: string;
  CartOrder: CartOrder;
  CartSummary: CartSummary;
  GoogleTagManagerDataLayerString: string;
  CurrencyCode: string;
  IsUser: boolean;
  OrderLevelPromotions: TalonOneItem[];
  PromoNotifications: EffectNotification[];
  FeatureFlagsSavedPaymentMethods: boolean;
  CanUseAmexForWebSales: boolean;
}

export enum AddressType {
  Billing = 'Billing',
  Shipping = 'Shipping',
}
export interface Address {
  AddressID: string;
  AddressType: AddressType;
  Description?: string;
  FirstName?: string;
  LastName?: string;
  Email?: string;
  Company: string;
  CountryID: number;
  CountryName: string;
  Address_: string;
  Address2: string;
  City: string;
  StateProvinceID?: number;
  StateProvinceName: string;
  PostalCodeZip: string;
  Phone: string;
}

export class PaypalExpressView {
  PaymentID: string;
  PayerID: string;
}
export enum PaymentType {
  GiftCard = 'GiftCard',
  CreditCard = 'CreditCard',
  SavedCreditCard = 'SavedCreditCard',
  PayPal = 'PayPal',
  Quote = 'Quote',
  Lease = 'Lease',
  Klarna = 'Klarna',
}
export class CartOrderOptions {
  CustomerComments: string;
  AcceptedTerms: boolean;
  AcceptedDropshipTerms: boolean;
  Auth: boolean;
  Enews: boolean;
}

export interface ProcessCheckoutResult {
  ReturnUrl: string;
  Errors: string[];
  Success: boolean;
}

export interface SelectAddress {
  AddressList: Address[];
  Message: string;
  DefaultBillingAddress: string;
  DefaultShippingAddress: string;
  AddressType: AddressType;
}
